import { CUSTOMER_SELF_ROLE } from '@careapp-group/core';
import { createSelector } from '@ngrx/store';
import { auth } from '../auth/auth.selectors';
import { State as AppState } from '../reducers/index';

export const getCustomersState = (state: AppState) => state.customers;

// Returns the CustomerDto of any customer the current user is acting as.
export const getSelfCustomer = createSelector(
  auth.getLoggedInUser,
  getCustomersState,
  (user, state) => {
    if (!user) {
      return null;
    }
    const customerSelfId = state.ids.find((id) => {
      return state?.entities[id]?.roles?.includes(CUSTOMER_SELF_ROLE) ?? false;
    });
    if (!!customerSelfId) {
      return state.entities[customerSelfId];
    }
    return null;
  }
);

export const getCustomerPaginators = createSelector(getCustomersState, (state) => {
  if (state != null && state.paginators != null) {
    return state.paginators;
  }
  return null;
});
